import {
  GET_REMITTERS_SUCCESS,
  GET_REMITTERS,
  GET_REMITTERS_FAILURE,
  SET_FITER_PARAMS,
  GET_RECOVERY_PASSWORD_LINK
} from "../constants/remittersActionsType";
import { GET_RECOVERY_PASSWORD_LINK_SUCCESS } from "../constants/remittersActionsType";
import { remitter as initialState } from "../constants/initialStates";

export const remitterReducer = (
  state = initialState,
  { data, error, type }
) => {
  switch (type) {
    case GET_REMITTERS:
      return {
        ...state,
        isLoading: true
      };

    case GET_REMITTERS_SUCCESS:
      return {
        ...state,
        remitter: data,
        isLoading: false
      };

    case GET_REMITTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error
      };
    case SET_FITER_PARAMS:
      const key = Object.keys(data)[0];
      const value = Object.values(data)[0];
      return {
        ...state,
        filterParams: {
          ...state.filterParams,
          [key]: value
        }
      };
    case GET_RECOVERY_PASSWORD_LINK:
      return {
        ...state,
        recoveryPasswordActions: {
          isLoading: true,
          email: data.email
        }
      };

    case GET_RECOVERY_PASSWORD_LINK_SUCCESS:
      return {
        ...state,
        recoveryPasswordLink: data.link,
        recoveryPasswordActions: {
          isLoading: false,
          email: data.email
        }
      };

    default:
      return state;
  }
};
